<template>
  <div class="circleContainer">
    <div
      class="dot"
      :class="[getCSSClass, notCircle ? 'notCircleDot' : 'circleDot']"
    >
      {{ id ? (id > 9 ? id : '0' + id) : '' }}
    </div>
    <div
      v-if="currentClass.includes('reviewSubmitDot')"
      class="smaller-dot"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'CircleComponent',
  props: {
    id: Number,
    currentClass: String,
    notCircle: Boolean,
  },
  computed: {
    getCSSClass: function() {
      return this.currentClass
    },
  },
}
</script>

<style scoped>
.smaller-dot {
  border-radius: 50%;
  height: 10px;
  width: 10px;
  background-color: #4caf50;
  margin-left: -7px;
}
.dot {
  font-size: 12px;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  box-sizing: border-box;
}
.circleDot {
  border-radius: 50%;
}
.notCircleDot {
  border-radius: 25%;
}
.reviewDot,
.reviewSubmitDot {
  background-color: #ffd600;
  color: #909191;
}
.normalDot {
  background-color: #ffffff;
  color: #909191;
}
.savedDot {
  background-color: #1bc09c;
  color: #ffffff;
}
.currentDot {
  border: 1px solid #18202f;
}
.activeDot {
  background: #0988f4;
}
.notActiveDot {
  background: #f5f6f7;
  color: #909191;
}
.notSelectedDot {
  background: #ffffff;
  border: 1px solid #d9d9d9;
}
.circleContainer {
  display: flex;
  width: fit-content;
  margin: auto;
}
</style>
